// Configuration for the application
// Controls whether to use mock backend or real AWS services

export interface AppConfig {
  useMockBackend: boolean;
  apiGatewayUrl?: string;
  cognitoUserPoolId?: string;
  cognitoClientId?: string;
}

// Use mock backend by default in development when AWS credentials are not configured
const USE_MOCK_BACKEND = 
  process.env.REACT_APP_USE_MOCK_BACKEND === 'true' ||
  process.env.REACT_APP_DEV_MODE === 'true' ||
  !process.env.REACT_APP_COGNITO_USER_POOL_ID ||
  !process.env.REACT_APP_COGNITO_CLIENT_ID ||
  !process.env.REACT_APP_API_URL;

export const config: AppConfig = {
  useMockBackend: USE_MOCK_BACKEND,
  apiGatewayUrl: process.env.REACT_APP_API_URL,
  cognitoUserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  cognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

export default config;
